var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"color":_vm.getColor(_vm.estado)}},on),[_vm._v("fiber_manual_record")])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.estado))])])
}
var staticRenderFns = []

export { render, staticRenderFns }